import { useMemo } from 'react';
import { useProductImages } from '~/atoms/hooks/useProductImages';
/**
 * Hook to get images for any entity type.
 *
 * Supports:
 * - product/style/model entities (via modelId from CPS)
 * - project entities (placeholder image as fallback)
 * - expression entities (mock image as fallback)
 *
 * This hook abstracts image fetching from entitySidebar,
 * making it easier to add entity-specific logic later.
 */
export function useEntityImages(entity, entityType) {
    const { getImagesForModel } = useProductImages();
    const images = useMemo(() => {
        if (!entity)
            return [];
        if (entityType === 'product' ||
            entityType === 'style' ||
            entityType === 'model') {
            const modelId = 'modelId' in entity && typeof entity.modelId === 'number'
                ? entity.modelId
                : null;
            if (!modelId)
                return [];
            const rawImages = getImagesForModel(String(modelId));
            return rawImages.map((img) => ({
                url: img.url,
                alt: 'styleName' in entity && entity.styleName
                    ? String(entity.styleName)
                    : 'modelName' in entity && entity.modelName
                        ? String(entity.modelName)
                        : undefined,
                viewCategory: img.viewCategory
            }));
        }
        if (entityType === 'project') {
            const project = entity;
            return [
                {
                    url: '/assets/projects/placeholder-project.png',
                    alt: project.projectName,
                    viewCategory: 'main'
                }
            ];
        }
        if (entityType === 'expression') {
            const expression = entity;
            return [
                {
                    url: '/assets/mockExpressionMain.png',
                    alt: expression.expressionName,
                    viewCategory: 'main'
                }
            ];
        }
        return [];
    }, [entity, entityType, getImagesForModel]);
    return { images };
}
